import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { BrandMonthConversion } from '../models/brandMonthConversion';

@Injectable({ providedIn: 'root' })

export class BrandMonthConversionService {

  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/brandMonthConversions';
  }
 
  getAll(id: any): Observable<Array<BrandMonthConversion>> {
    const url = this._ENDPOINT + '/?brandId=' + id;
    return this.http.get<Array<BrandMonthConversion>>(url); 
  }

  getById(id: any): Observable<BrandMonthConversion> {
    const url = this._ENDPOINT + '/' + id;
    return this.http.get<BrandMonthConversion>(url);
  }

  /** POST: add a new brandMonthConversion to the server */
  add(brandMonthConversion: BrandMonthConversion): Observable<BrandMonthConversion> {
    return this.http.post<BrandMonthConversion>(this._ENDPOINT, brandMonthConversion, this.httpOptions).pipe(
      tap((newBrandMonthConversion: BrandMonthConversion) => this.log('added month conversion w/ id=${newBrandMonthConversion.id}')),
      catchError(this.handleError<BrandMonthConversion>('add'))
    );
  }

  /** DELETE: delete the brandMonthConversion from the server */
  delete(id: number): Observable<BrandMonthConversion> { 
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<BrandMonthConversion>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted brandMonthConversion id=${id}')),
      catchError(this.handleError<BrandMonthConversion>('deleteBrandMonthConversion'))
    );
  }

  /** PUT: update the brandMonthConversion on the server */
  update(id: number, brandMonthConversion: BrandMonthConversion): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, brandMonthConversion, this.httpOptions).pipe(
      tap(_ => this.log('updated brandMonthConversion id=${brandMonthConversion.Id}')),
      catchError(this.handleError<any>('updateBrandMonthConversion'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a BrandMonthConversionService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`BrandMonthConversionService: ${message}`);
  }
}
